export const i18nInjectionKey = Symbol('i18n');

export const languageInjectionKey = Symbol('language');

export const communityInjectionKey = Symbol('community');

export const tokenInjectionKey = Symbol('token');

export const storeInjectionKey = Symbol('store');
